import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { EDIT_PLANING, LIST_PLANING } from "../../Utils/constant";
import { updateOne } from "../../services/service";
import { useStoreCreneau } from "../../store/Paramettre/creneauStore";
import { useGlobalStore } from "../../store/store";
import { SubmitButton } from "../Widget/SubmitButton";
export const PlaningFormUpdate = ({ item }) => {
    console.log(item);
    const [dateStartSurv, setStartDateSurv] = useState(new Date());
    const [isSubmit, setIsSubmit] = useState(false)
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const creneau = useStoreCreneau();
    const planing = useGlobalStore()
    useEffect(() => {
        creneau.creneau({ page: 0, param: "", size: 10 });
    }, []);

    const submit = (data) => {
        updateOne(EDIT_PLANING, item?.publicId,
            {
                equipeId: item?.extendedProps?.equipe?.id,
                creneauId: data.creneauIdSurv,
                date: dateStartSurv.toLocaleDateString().replace(/\//g, "-"),
            }).then((res) => {
                setIsSubmit(true)
                if (res.status === 200) {
                    planing.getData(LIST_PLANING)
                    document.getElementById('fermer').click()
                    document.getElementById('close').click()
                    setIsSubmit(null)
                    toast.success('Planification modifiée')
                }
            }).catch((err) => {
                setIsSubmit(false)
                document.getElementById('fermer').click()
                document.getElementById('close').click()
                toast.error(err?.response?.data?.donnee)
            })
    };

    return (
        <form onSubmit={handleSubmit(submit)}>
            <div className="">
                <div className="w-full  mx-auto  mt-6">
                    <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                        <label className="form-control flex flex-col  gap-2  w-full">
                            <label className="form-control  w-full">
                                <div className="label -mb-1 w-fit">
                                    <span className="label-text font-medium text-gray-400">
                                        Date
                                    </span>
                                </div>

                                <div className="flex lg:flex-row md:flex-row xl:flex-row flex-col gap-2">
                                    <ReactDatePicker
                                        locale="fr"
                                        dateFormat="dd-MM-yyyy"
                                        minDate={new Date()}
                                        selected={dateStartSurv}
                                        className="  px-2 flex items-center justify-center border-[1px] h-8 rounded-lg"
                                        onChange={(date) => {
                                            setStartDateSurv(date)
                                        }}
                                    />
                                </div>
                            </label>
                            <div className="flex flex-row gap-2">
                                <label className="form-contro  w-full">
                                    <div className="label -mb-1">
                                        <span className="label-text font-medium text-gray-400">
                                            Créneau horaire
                                        </span>
                                    </div>

                                    <select
                                        {...register("creneauIdSurv", { required: true })}
                                        className="select select-bordered w-full h-10"
                                    >
                                        <option value={''} disabled selected>
                                            Choisir un Créneau
                                        </option>
                                        {creneau?.data?.data?.filter(e => e?.isActif === true).map((item) => (
                                            <option value={item.id}>
                                                {item.heureDebut} - {item.heureFin}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                            </div>
                        </label>
                    </div>

                </div>
                <SubmitButton isSubmit={isSubmit} label={'Enregistrer'} />
            </div >
        </form >

    );
};
